export default "/fonts/vendor/@fortawesome/fontawesome-free/webfa-solid-900.ttf?32267f3b4db33a7c85ee31d9b317c9e4";